export { SimuladorStateProvider, useSimuladorEnergiaSolarState } from './context';
